import { useState } from "react";
import { guideTabs } from "../../../mocks/guaData";

export default function Guides() {
  const [activeKey, setActiveKey] = useState(guideTabs[0].key);
  const active = guideTabs.find((t) => t.key === activeKey) ?? guideTabs[0];

  return (
    <section id="guides" className="w-full bg-background-100 py-14 md:py-20" aria-label="玩法攻略与安利">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="text-sm font-semibold uppercase tracking-wider text-accent-600">Guides</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            吃瓜玩法攻略：入门、进阶与安利一把抓
          </h2>
          <p className="mt-3 text-base leading-relaxed text-foreground-600">
            无论你是刚下载的小白，还是想玩出花样的老手，这里都有一套可以直接照做的攻略。
            选一个方向开始，马上用起来。
          </p>
        </div>

        <div
          className="mt-8 inline-flex rounded-full bg-background-50 p-1 ring-1 ring-background-200"
          role="tablist"
          aria-label="攻略分类切换"
        >
          {guideTabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={activeKey === tab.key}
              onClick={() => setActiveKey(tab.key)}
              className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors md:px-5 ${
                activeKey === tab.key
                  ? "bg-primary-500 text-white"
                  : "text-foreground-700 hover:bg-primary-50 hover:text-primary-700"
              }`}
            >
              <i className={tab.icon} aria-hidden="true"></i>
              {tab.label}
            </button>
          ))}
        </div>

        <div className="mt-6 rounded-lg bg-background-50 p-6 ring-1 ring-background-200 md:p-8">
          <div className="flex flex-col gap-6 lg:flex-row lg:gap-10">
            <div className="lg:w-2/5">
              <h3 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">{active.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{active.intro}</p>
              <div className="mt-5 flex items-center gap-3 rounded-md bg-accent-100 p-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-500 text-white">
                  <i className="ri-check-double-line text-lg" aria-hidden="true"></i>
                </span>
                <p className="text-sm font-medium leading-relaxed text-accent-900">{active.result}</p>
              </div>
            </div>

            <ol className="relative flex-1 space-y-4 border-l-2 border-primary-200 pl-6">
              {active.steps.map((step, idx) => (
                <li key={idx} className="relative">
                  <span className="absolute -left-[31px] top-1 flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 text-xs font-bold text-white">
                    {idx + 1}
                  </span>
                  <p className="text-sm leading-relaxed text-foreground-700">{step}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}